<template>
	<div>
		<div class="global-tool-bar">
		    <div class="left-bar">
		        <span class="title">联系我们列表</span>
		    </div>
		</div>
		<stand-pagination-table :columns="mainTable.columns"
			:data="mainTable.data"
			:loading="mainTable.loading"
			:table-search="mainTable.tableSearch"
			:table-load-event="getContactTableRecords"
			>
		</stand-pagination-table>
		
		<Modal v-model="ContactFromShow"
				title="联系我们" width="800px">
				<Form label-position="top">
					<Row :gutter="16">
						<Col span="24">
						<FormItem label="标题">
							<Input v-model="ContactFrom.title"></Input>
						</FormItem>
						</Col>
						<Col span="24">
						<FormItem label="内容">
							<quill-editor v-model="ContactFrom.content"></quill-editor>
						</FormItem>
						</Col>
					</Row>
				</Form>
				<div slot="footer">
					<Button type="success"
						class="form-button"
						@click="onContactSave">保存</Button>
					<Button type="text"
						class="form-button"
						@click="onContactCancel">取消</Button>
				</div>
			</Modal>
	</div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
	
import { quillEditor } from 'vue-quill-editor';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { getNoticeList, saveNotice } from '@/api/modules/system-management/notice-management';
import { dateTimeRender, dateRender } from '@/libs/tableRowTimeRender';
import search from '@/libs/search';
export default {
    name:'ContactUs',
    components:{ StandPaginationTable, quillEditor },
    data() {
        return {
            ContactFrom:{
                title:'',
                noticeUuid:'',
                content:'',
                noticeType:''
            },
            contactSource: [],
            ContactFromShow:false,
            mainTable:{
                columns:[
                    { title:'序号', type:'index', width: 40, align: 'center' },
                    { title:'标题', key:'title', align: 'center' },
                    { title:'创建时间', key:'createTime', width:120, align: 'center', render: (h, params) => dateTimeRender(h, params.row.createTime) },
                    { title: '修改时间', key: 'modifyTime', align: 'center', render: (h, params) => dateTimeRender(h, params.row.modifyTime) },
                    {
					    title: '操作',
					    key: 'action',
					    align: 'center',
					    render: (h, params) => {
					        return h('div', [
					            h('Button', {
					                props: {
					                    type: 'text',
					                    size: 'small'
					                },
					                style: {},
					                on: {
					                    click: () => {
					                        this.onContactUpdate(params.row);
					                    }
					                }
					            }, '编辑',)]);
					    }
                    }
                ],
                data:[],
                loading:false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted(){
        this.getContactTableRecords();
    },
    methods: {
        getContactTableRecords(reset = false){
            this.mainTable.tableLoading = true;
			
            if (reset) {
			    search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.filters.enable = true;
            this.mainTable.tableSearch.filters.conditions.push({ value: '联系我们', name: 'noticeType', type:'eq' });
            getNoticeList(this.mainTable.tableSearch).then(res => {
			    if (res.code === 0) {
			        this.mainTable.data = res.data.records;
			        search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
			    }
			
			    this.mainTable.tableLoading = false;
            }).catch(() => {
			    this.mainTable.tableLoading = false;
            });
        },
        onContactUpdate(row){
            // this.ContactFrom.Contactid = row.Contactid;
            this.ContactFrom.noticeUuid = row.noticeUuid;
            this.ContactFrom.title = row.title;
            this.ContactFrom.content = row.content;
            this.ContactFrom.noticeType = '联系我们';
            this.ContactFromShow = true;
        },
        onContactCancel() {
		    this.ContactFromShow = false;
        },
        onContactSave() {
            const data = Object.assign({}, this.ContactFrom);
            saveNotice(data).then(res => {
			    if (res.code === 0) {
			        this.$Modal.success({
			            title: '保存成功',
			            onOk: () => {
			                this.ContactFromShow = false;
			                this.getContactTableRecords();
			            }
			        });
			    }
            });
        }
    }
};
</script>

<style>
</style>
